import { CompassCardUI } from '@scale/compass-ui/types';
import GroupByCardComponent from 'react-scale/corp/views/DataCompassCardsV2/transformation/GroupByCard/GroupByCardComponent';
import { faLayerGroup } from '@fortawesome/pro-solid-svg-icons';
import {
  GroupByCardShared,
  type GroupBySchemaType,
  type GroupByContext,
  GROUP_BY,
} from '@scale/genai-compass-shared/cards/group_by';

const defaultContext: GroupByContext = {
  cardType: GROUP_BY,
};

export const GroupByCardInfo: CompassCardUI<GroupBySchemaType> = {
  ...GroupByCardShared,
  title: 'Group By',
  icon: 'objects-column',
  toolTip: 'Group rows that have the same values into summary rows.',
  defaultContext,
  ownerTeam: 'Compass Core',
  legacyComponent: GroupByCardComponent,
  button: {
    icon: faLayerGroup,
  },
};
